import {gsap, Observer, ScrollTrigger} from "../LibrariesImport";
import {GlobalVariables} from "../GlobalVariables";

export default class Banner {
	static init() {

		this.banner = document.querySelector('.banner');

		if( this.banner.classList.contains('banner-text-only')){
			this.textOnlyAnimation();
		}

		if( this.banner.querySelector('.alert')){
			this.scrollingAlert();
		}

		if( this.banner.querySelector('.scrolldown') ){
			this.ctaScrollDown();
		}

		ScrollTrigger.create({
			trigger: this.banner,
			start: "bottom top",
			endTrigger: '.footer-main',
			end: "top bottom",
			toggleClass: {
				targets: '.sticky-btn-booking',
				className: "visible"
			}
		});

	}

	static scrollingAlert(){

		const alert = this.banner.querySelector('.alert');
		const scrollingText = alert.querySelectorAll('.text');
		const width = scrollingText[0].offsetWidth;
		const multiplier = window.innerWidth > 767 ? 40 : 70;

		setTimeout(() => {
			gsap.to(scrollingText, {
				xPercent: -200,
				duration: (width / window.innerWidth) * multiplier,
				ease: "linear",
				repeat: -1
			});
		});

	}

	static ctaScrollDown(){

		let btn = this.banner.querySelector('.scrolldown');
		btn.addEventListener('click', () => {
			window.scrollTo({
				behavior: 'smooth',
				top: this.banner.offsetHeight
			});
		});
	}

	static textOnlyAnimation(){
		this.vegetations = this.banner.querySelectorAll(".vegetation");
		this.images = this.banner.querySelectorAll(".vegetation img");
		const unloadedImages = [];

		this.images.forEach(img => {
			if (!img.complete || img.naturalWidth === 0) {
				unloadedImages.push(img.src || img.getAttribute('data-src'));
			}
		});

		if (unloadedImages.length === 0) {
			this.timeline = gsap.timeline({
				onComplete: () => {
					this.vegetations.forEach((el, index) => {
						this.positions[index] = {
							xPercent: gsap.getProperty(el, "xPercent"),
							yPercent: gsap.getProperty(el, "yPercent")
						};
						this.quickX[index] = gsap.quickTo(el, "xPercent", { duration: 0.3, ease: "power2.out" });
						this.quickY[index] = gsap.quickTo(el, "yPercent", { duration: 0.3, ease: "power2.out" });
					});
					this.vegetationAnimation();
				}
			});

			this.positions = [];
			this.quickX = [];
			this.quickY = [];

			this.timeline.from(this.vegetations, {
				duration: 0.8,
				xPercent: (index, target) => target.dataset.xFrom || 100,
				ease: "power1.ease",
				stagger: 0.15
			});
		}

	}

	static vegetationAnimation(){

		// const container = document.querySelector(this.banner);
		this.banner.addEventListener("mousemove", (event) => {
			if (this.positions.length === 0) return;
			const { left, top, width, height } = this.banner.getBoundingClientRect();
			const relativeX = event.clientX - left;
			const relativeY = event.clientY - top;

			const xMove = (relativeX / width - 0.5) * 2; // Mouvement ajusté au conteneur
			const yMove = (relativeY / height - 0.5) * 2.5;

			this.vegetations.forEach((el, index) => {
				this.quickX[index](this.positions[index].xPercent + xMove * (1 + index * 0.05));
				this.quickY[index](this.positions[index].yPercent + yMove * (1 + index * 0.05));
			});
		});

		this.banner.addEventListener("mouseleave", () => {
			if (this.positions.length === 0) return;

			this.vegetations.forEach((el, index) => {
				this.quickX[index](this.positions[index].xPercent);
				this.quickY[index](this.positions[index].yPercent);
			});
		});

	}

}
